import { Box, Button, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridRowParams, GridSelectionModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MyRenderCell } from "../../components";
import { Loading } from "../../components/Loading";
import { RootState, getCurrentBatchOpen, getMaterialsPerSubActivity, getStudentsByOpenBatch, getTempMaterialsPerSubActivity, processBatch, useAppDispatch, useAppSelector } from "../../redux";
import { calcQuantityMaterialsPerSubActivity, checkAvailability } from "../../utilities/batchUtil";

export const OpenBatches = () => {
    const [pageSize, setPageSize] = useState<number>(50);

    const { id } = useParams();
    const dispatch = useAppDispatch();
    const { isLoading, currentBatch, studentsBatches = [] } = useAppSelector((state: RootState) => state.batches);

    const { isLoading: isMaterialsLoading, materialsPerSubActivity = [], tempMaterialsPerSubActivity = []
        , materialsPerSubActivityBase = [], selectedIdMaterialsPerSubActivity = [] } = useAppSelector((state: RootState) => state.materials);

    useEffect(() => {
        if (id) {
            dispatch(getCurrentBatchOpen(+id));
            dispatch(getStudentsByOpenBatch(+id));
            dispatch(getMaterialsPerSubActivity(+id));
        }
    }, [dispatch, id])

    const Columns: GridColDef[] = [
        {
            field: 'id',
            headerName: 'id',
            width: 150,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'lastName',
            headerName: 'Last Name',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'shipToName',
            headerName: 'Ship To Name',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'address',
            headerName: 'Address',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'city',
            headerName: 'City',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'state',
            headerName: 'State',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'zipCode',
            headerName: 'Zip Code',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'country',
            headerName: 'Country',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'phone',
            headerName: 'phone',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'syStudentId',
            headerName: 'SyStudent Id',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'topSize',
            headerName: 'Top Size',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
        {
            field: 'bottomSize',
            headerName: 'Bottom Size',
            width: 250,
            renderCell: (params) => (<MyRenderCell params={params} />)
        },
    ]

    const handleSelectionModelChange = (selectionModel: GridSelectionModel) => {
        const result = calcQuantityMaterialsPerSubActivity(materialsPerSubActivity, materialsPerSubActivityBase, selectionModel, studentsBatches)
        dispatch(getTempMaterialsPerSubActivity(result, selectionModel as number[]));
    };

    const handleIsRowSelectable = (params: GridRowParams) => {
        const selected = selectedIdMaterialsPerSubActivity.includes(+params.id);
        const currentStudent = studentsBatches.find(student => student.id === +params.id);

        checkAvailability(currentStudent, materialsPerSubActivity);

        return selected || checkAvailability(currentStudent, tempMaterialsPerSubActivity);;
    }

    const onClick = () => {
        let selectedStudents = studentsBatches.filter(student => selectedIdMaterialsPerSubActivity.includes(student.id));

        if (id) {
            dispatch(processBatch(selectedStudents, materialsPerSubActivity, currentBatch));
        }
    };
    return (
        <div>
            <Loading isLoading={isLoading || isMaterialsLoading} />
            <br />
            <div className="work-container">
                <div className="work-container-title-container">
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h4" component="h1">
                            {currentBatch.activityName}
                            <span style={{ fontSize: '0.7em', marginLeft: '0.5rem' }}>
                                - {currentBatch.uniqueIdentifier}
                            </span>
                        </Typography>
                        <Button variant="contained" type="submit" sx={{ width: 100 }} onClick={onClick}>Save</Button>
                    </Box>
                    <br />
                    <DataGrid
                        rows={studentsBatches}
                        columns={Columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[10, 50, 100]}
                        columnVisibilityModel={{ id: false, }}
                        checkboxSelection
                        onSelectionModelChange={handleSelectionModelChange}
                        isRowSelectable={handleIsRowSelectable}
                    />
                </div>
                <div style={{ height: "calc(100vh - 250px)", width: '30%', flexGrow: 1 }}>
                    <Typography variant="h5" component="h2" sx={{ height: '41.98px', display: 'flex', alignItems: "flex-end" }}>
                        Current Inventory Quantity
                    </Typography>

                    <br />
                    <table className="work-inventory-table">
                        <thead>
                            <tr>
                                <th>Items</th>
                                <th>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tempMaterialsPerSubActivity.map((item) => (
                                <tr key={item.isbn}>
                                    <td><strong>Isbn:</strong> {item.isbn}<br /><strong>Name:</strong> {item.name}</td>
                                    <td>{item.availableQuantity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div >
    );
};
